import React from "react";

type Props = {
  disabled?: boolean;
  children: React.ReactNode;
};

export default function Disabled({ disabled = false, children }: Props) {
  const opacity: number = disabled ? 0.4 : 1;
  return (
    <div
      style={{
        opacity: opacity,
        position: "relative",
      }}
    >
      {children}
      {disabled && (
        <div
          style={{
            position: "absolute",
            zIndex: 999,
            top: "0px",
            bottom: "0px",
            left: "0px",
            right: "0px",
          }}
        />
      )}
    </div>
  );
}
